module.exports = __webpack_public_path__ + "media/src/images/icon/tel-sm-ef8e1f1e6b2143b5526a61788a9f5683.png";